export default "__VITE_ASSET__SpsCZXYd__"